// extracted by mini-css-extract-plugin
export var externalLink = "_9c-0";
export var internalLinkLabel = "_9c-1";